export var recordDataFieldsToProposalData = function (fields) {
    var _a, _b, _c, _d;
    var flat = [];
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var field = fields_1[_i];
        for (var _e = 0, _f = field.subfields; _e < _f.length; _e++) {
            var sub = _f[_e];
            var components = sub.components.map(function (c) { return ({
                component_type: c.componentType,
                value: c.value,
            }); });
            flat.push({
                field_tag: field.fieldTag,
                field_index: field.fieldIndex,
                indicator1: (_a = field.indicator1) !== null && _a !== void 0 ? _a : undefined,
                indicator2: (_b = field.indicator2) !== null && _b !== void 0 ? _b : undefined,
                subfield_code: sub.subfieldCode,
                subfield_index: sub.subfieldIndex,
                value: sub.value,
                source_authority_id: (_c = sub.sourceAuthorityId) !== null && _c !== void 0 ? _c : undefined,
                source_heading_id: (_d = sub.sourceHeadingId) !== null && _d !== void 0 ? _d : undefined,
                components: components.length > 0 ? components : undefined,
            });
        }
    }
    return flat;
};
/* eslint-enable camelcase */
